<template>
  <div class="aiz-main-wrapper">

  </div>
</template>

<script>
	import {loginToken} from '../../api/api.js'
	export default {
		data() {
			return {
				// 登录表单
				loginForm: {
          email: null, // 系统账户
					password: null, // 系统密码
					rememberMe: false,
          fullName:false
				},
			}
		},
		created() {
      this.confirmLogin()
		},
		beforeDestroy() {

		},
		mounted() {},
		methods: {
			confirmLogin(){
				var that = this;
				let params = {
					token:this.$route.query.token,
				}
        loginToken(params).then(res => {
					if (res.code == 200) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('fullName', that.loginForm.fullName);
            localStorage.setItem('email', that.loginForm.email);
            this.$router.push({ path: this.redirect || "/" })
					}else{
            localStorage.removeItem('token');
            localStorage.removeItem('fullName');
            localStorage.removeItem('email');
						that.$message.warning(res.msg);
						return false;
					}

				})
			}
		}
	}
</script>

<style scoped>
	body {
		margin: 0;
		font-family: Poppins, Helvetica, sans-serif;
		font-size: 13px;
		font-weight: 400;
		line-height: 1.5;
		color: #1b1b28;
		background-color: #fff;
		max-width: 100vw;
		overflow-x: hidden;
	}

	.aiz-main-wrapper {
		min-height: 100vh;
		max-width: 100vw;
		background-color: #f2f3f8;
		display: flex;
	}

	.flex-grow-1 {
		-ms-flex-positive: 1;
		flex-grow: 1;
	}

	.bg-cover {
		background-image: url('../../assets/images/login_bg.png');
		background-size: cover;
		background-position: center center;
		padding-bottom: 3rem;
		padding-top: 3rem;
		/* height: calc(100% - 6rem); */
		height: 100%;
		display: flex;
		align-items: center;
	}

	.login-container {
		max-width: 1140px;
		width: 100%;
		padding-right: 15px;
		padding-left: 15px;
		margin-right: auto;
		margin-left: auto;
	}

	.row {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-right: -15px;
		margin-left: -15px;
	}

	.ml-auto,
	.mx-auto {
		margin-left: auto !important;
	}

	.mr-auto,
	.mx-auto {
		margin-right: auto !important;
	}

	.col-xl-4 {
		-ms-flex: 0 0 43.333333%;
		flex: 0 0 43.333333%;
		max-width: 43.333333%;
	}
	@media (max-width: 767px) {
		.col-xl-4 {
			-ms-flex: 0 0 90%;
			flex: 0 0 90%;
			max-width: 90%;
		}
	}

	.col,
	.col-1,
	.col-10,
	.col-11,
	.col-12,
	.col-2,
	.col-3,
	.col-4,
	.col-5,
	.col-6,
	.col-7,
	.col-8,
	.col-9,
	.col-auto,
	.col-lg,
	.col-lg-1,
	.col-lg-10,
	.col-lg-11,
	.col-lg-12,
	.col-lg-2,
	.col-lg-3,
	.col-lg-4,
	.col-lg-5,
	.col-lg-6,
	.col-lg-7,
	.col-lg-8,
	.col-lg-9,
	.col-lg-auto,
	.col-md,
	.col-md-1,
	.col-md-10,
	.col-md-11,
	.col-md-12,
	.col-md-2,
	.col-md-3,
	.col-md-4,
	.col-md-5,
	.col-md-6,
	.col-md-7,
	.col-md-8,
	.col-md-9,
	.col-md-auto,
	.col-sm,
	.col-sm-1,
	.col-sm-10,
	.col-sm-11,
	.col-sm-12,
	.col-sm-2,
	.col-sm-3,
	.col-sm-4,
	.col-sm-5,
	.col-sm-6,
	.col-sm-7,
	.col-sm-8,
	.col-sm-9,
	.col-sm-auto,
	.col-xl,
	.col-xl-1,
	.col-xl-10,
	.col-xl-11,
	.col-xl-12,
	.col-xl-2,
	.col-xl-3,
	.col-xl-4,
	.col-xl-5,
	.col-xl-6,
	.col-xl-7,
	.col-xl-8,
	.col-xl-9,
	.col-xl-auto {
		position: relative;
		width: 100%;
		padding-right: 15px;
		padding-left: 15px;
	}

	.text-left {
		text-align: left !important;
	}

	.card {
		position: relative;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-direction: column;
		flex-direction: column;
		min-width: 0;
		word-wrap: break-word;
		background-color: #fff;
		background-clip: border-box;
		border: 1px solid rgba(0, 0, 0, .125);
		border-radius: .25rem;
		box-shadow: 0 0 13px 0 rgba(82, 63, 105, 0.05);
		background-color: #fff;
		margin-bottom: 20px;
		border-color: #ebedf2;
	}

	.card-body {
		-ms-flex: 1 1 auto;
		flex: 1 1 auto;
		min-height: 1px;
		padding: 1.25rem;
	}

	.text-center {
		text-align: center !important;
	}

	.mb-5,
	.my-5 {
		margin-bottom: 3rem !important;
	}

	.mb-4,
	.my-4 {
		margin-bottom: 1.5rem !important;
	}

	.mw-100 {
		max-width: 100% !important;
	}

	img {
		vertical-align: middle;
		border-style: none;
	}

	.text-primary {
		color: #5C71F8;
	}

	.mb-0,
	.my-0 {
		margin-bottom: 0 !important;
	}

	.mb-2,
	.my-2 {
		margin-bottom: .5rem !important;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin-top: 0;
		margin-bottom: .5rem;
	}

	.h1,
	.h2,
	.h3,
	.h4,
	.h5,
	.h6,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin-bottom: .5rem;
		font-weight: 500;
		line-height: 1.2;
	}

	.h3,
	h3 {
		font-size: 1.75rem;
	}

	p {
		margin-top: 0;
		margin-bottom: 1rem;
	}

	.form-group {
		margin-bottom: 1rem;
	}

	.form-control {
		display: block;
		width: calc(100% - 2rem);
		padding: 0.6rem 1rem;
		font-size: 0.875rem;
		height: 27px;
		border: 1px solid #e2e5ec;
		color: #898b92;
		font-weight: 400;
		line-height: 1.5;
		background-color: #fff;
		background-clip: padding-box;
		border-radius: .25rem;
		transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	}


	.row {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-right: -15px;
		margin-left: -15px;
	}

	.col-sm-6 {
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
	}

	.text-left {
		text-align: left !important;
	}

	.aiz-checkbox,
	.aiz-radio {
		display: inline-block;
		position: relative;
		padding-left: 28px;
		margin-bottom: 10px;
		cursor: pointer;
		font-size: 0.875rem;
		-webkit-transition: all 0.3s ease;
		transition: all 0.3s ease;
	}

	.aiz-checkbox>input,
	.aiz-radio>input {
		position: absolute;
		z-index: -1;
		opacity: 0;
	}

	input[type=checkbox],
	input[type=radio] {
		box-sizing: border-box;
		padding: 0;
	}

	.aiz-square-check,
	.aiz-rounded-check {
		background: 0 0;
		position: relative;
		height: 16px;
		width: 16px;
		border: 1px solid #d1d7e2;
	}

	.aiz-square-check {
		border-radius: 3px;
	}

	.aiz-checkbox .aiz-square-check,
	.aiz-checkbox .aiz-rounded-check,
	.aiz-radio .aiz-square-check,
	.aiz-radio .aiz-rounded-check {
		position: absolute;
		top: 2px;
		left: 0;
	}

	.aiz-square-check:after,
	.aiz-rounded-check:after {
		content: "";
		position: absolute;
		visibility: hidden;
		opacity: 0;
		top: 50%;
		left: 50%;
		-webkit-transition: all 0.3s ease;
		transition: all 0.3s ease;
	}

	.aiz-square-check:after {
		margin-left: -2px;
		margin-top: -6px;
		width: 5px;
		height: 10px;
		border-width: 0 2px 2px 0 !important;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		border: solid #3F36F6;
	}

	.text-right {
		text-align: right !important;
	}

	.text-reset {
		color: inherit !important;
	}

	.fs-14 {
		font-size: 0.875rem !important;
	}

	.btn {
		text-align: center;
		vertical-align: middle;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		border: 1px solid transparent;
	}

	.btn-group-lg>.btn,
	.btn-lg {
		padding: .5rem 1rem;
		font-size: 1.25rem;
		line-height: 1.5;
		border-radius: .3rem;
	}

	.btn-block {
		display: block;
		width: 100%;
	}

	.btn-lg {
		padding: 0.75rem 1.5rem;
		font-size: 1rem;
	}

	.btn-primary,
	.btn-soft-primary:hover,
	.btn-outline-primary:hover {
		background-color: #5C71F8;
		border-color: #5C71F8;
		color: #fff;
	}

	.btn:not(:disabled):not(.disabled) {
		cursor: pointer;
	}


	.card .card-body {
		padding: 20px 25px;
		border-radius: 4px;
	}
</style>
